export enum Roles {
  MONITOR = 'livechat-monitor',
  AGENT = 'livechat-agent',
  MANAGER = 'livechat-manager',
}

export const managementRoles = [Roles.MONITOR, Roles.MANAGER];
